import * as types from "../mutation-types";
import router from "../../router";

const state = {
  tabs: JSON.parse(sessionStorage.getItem("tab")) || { tablist: [] },
  currentName: sessionStorage.getItem("currentName")
};

//getters
const getters = {
  alltab: state => state.tabs.tablist,
  currentName(state) {
    return state.currentName
      ? state.currentName
      : "<img src='/static/image/Aquilafly-Cloud.png' class='logo'>";
  }
};

// actions
const actions = {
  addtab({ commit, state }, items) {
    commit(types.ADD_TO_TAG, items);
  },
  deltab({ commit, state }, { index }) {
    commit(types.DEL_TAG, { index });
  },
  getcurrentname({ commit, state }, cur_name) {
    commit(types.CURRENT_NAME, cur_name);
  },
  clearcurrentname({ commit, state }) {
    commit(types.CLEAR_CURRENT_NAME);
  },
  cleartabs({ commit, state }) {
    commit(types.CLEAR_TABS);
  }
};

// mutations
const mutations = {
  [types.ADD_TO_TAG](state, items) {
    addtabs(items);
  },
  [types.DEL_TAG](state, { index }) {
    deltabs(index);
  },
  [types.CURRENT_NAME](state, cur_name) {
    getcurrentbrand(cur_name);
  },
  [types.CLEAR_CURRENT_NAME](state) {
    clearcurrentbrand();
  },
  [types.CLEAR_TABS](state) {
    cleartab();
  }
};
function cleartab() {
  state.tabs = { tablist: [] };
  sessionStorage.removeItem("tab");
}
function clearcurrentbrand() {
  state.currentName = "";
  sessionStorage.removeItem("currentName");
}
function getcurrentbrand(cur_name) {
  let brands = cur_name.join("<i class='sep'>/</i>");
  state.currentName = brands;
  sessionStorage.currentName = brands;
}
//保存tab标签页
function savetab() {
  sessionStorage.tab = JSON.stringify(state.tabs);
}

//添加tab标签页
function addtabs(items) {
  if (!filter(items)) {
    state.tabs.tablist.push(items);
    savetab();
  }
}
//删除tab标签页
function deltabs(index) {
  let url = removetab(index);
  state.tabs.tablist.splice(index, 1);

  savetab();
  golink(url);
}
//判断是否已经存在
function filter(items) {
  let count = 0;
  state.tabs.tablist.forEach(function(item) {
    if (item.tabitem.menuName == items.tabitem.menuName) {
      count++;
    }
  });
  if (count > 0) {
    return true;
  } else {
    return false;
  }
}

//删除后切换tab
function removetab(index) {
  let url = {};
  let nextTab = state.tabs.tablist[index + 1] || state.tabs.tablist[index - 1];
  if (nextTab) {
    if (
      nextTab.tabitem.menuName == "申请" ||
      nextTab.tabitem.menuName == "消息"
    ) {
      clearcurrentbrand();
      url.path = nextTab.tabitem.url;
      //url.query={id:nextTab.tabitem.menuId};
    } else {
      url.path = nextTab.tabitem.url;
      getcurrentbrand([
        nextTab.menuitem,
        nextTab.subitem,
        nextTab.subitem.title
      ]);
    }
  } else {
    url.path = "/home/workbench";
    clearcurrentbrand();
  }
  return url;
}
//跳转
function golink(url) {
  router.push(url);
}

export default {
  state,
  getters,
  actions,
  mutations
};
